import { OFFERS_LISTING_URL_EVENT } from "../utils/listing-url";
import { useMemo, useSyncExternalStore } from "react";
function subscribe(onStoreChange) {
    document.addEventListener(OFFERS_LISTING_URL_EVENT, onStoreChange);
    return () => document.removeEventListener(OFFERS_LISTING_URL_EVENT, onStoreChange);
}
function getSnapshot() {
    return window.location.pathname + window.location.search;
}
/**
 * Subscribes to the shared `offersListing:urlchange` event (dispatched by
 * `navigateToListingUrl` and re-dispatched by the legacy JS side on
 * popstate) so components re-render when the listing URL changes, instead
 * of reading `window.location` directly during render.
 */
export function useListingLocation() {
    const href = useSyncExternalStore(subscribe, getSnapshot);
    return useMemo(() => {
        const url = new URL(href, window.location.origin);
        return { pathname: url.pathname, search: url.search };
    }, [href]);
}
